<div *ngIf="hasData$ | async" class="floating-banner" [class.show]="isVisible">
    <div class="flex flex-col gap-8 flex-1">
        <div class="flex flex-col gap-4 self-stretch">
            <div [innerHTML]="bannerData!.title"></div>
            <div [innerHTML]="bannerData!.description"></div>
        </div>
        <a *ngIf="bannerData!.cta" [href]="bannerData!.cta!.url" class="btn btn-primary w-fit">{{ bannerData!.cta!.text }}</a>
    </div>
    <div class="md:block hidden">
        <img [src]="cmsApiUrl + bannerData!.backgroundImageUrl" alt="background" />
    </div>
    <button class="absolute top-6 right-6" (click)="closeBanner()">
        <i class="icon-close"></i>
    </button>
</div>
